import { AspectRatio, Button } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';
import { useTranslation } from 'react-i18next';

import styles from './WelcomeVideoModal.module.scss';

const WelcomeVideoModal = ({
  context,
  id,
  innerProps,
}: ContextModalProps<{ onConfirm?: () => void }>) => {
  const { t } = useTranslation();

  const handleClose = () => {
    context.closeModal(id);
    innerProps.onConfirm?.();
  };

  return (
    <>
      <div className={styles.discover}>
        {t(
          'onboarding.video.subtitle',
          "Découvrez toutes les fonctionnalités de l'application en quelques secondes !"
        )}
      </div>
      <AspectRatio ratio={16 / 9}>
        <iframe
          src={`https://www.youtube.com/embed/${import.meta.env.VITE_WELCOME_VIDEO_ID}`}
          title="Lecteur vidéo YouTube"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </AspectRatio>

      <div className={styles.buttons}>
        <Button onClick={handleClose}>
          {t('onboarding.video.close', "Accéder à l'application")}
        </Button>
      </div>
    </>
  );
};

export default WelcomeVideoModal;
